export const BUILD_ID = '28fe4046-1e4d-43eb-be62-ee7ddf854f17';
export const ENV = 'dev';
